<div class="admin-logs-page">
  <div class="admin-logs-header">
    <div>
      <h1>Logs API</h1>
      <p>Visualización en tiempo real del log diario del servidor.</p>
    </div>

    <div class="admin-logs-status" [class.online]="connected">
      <span></span>
      {{ connected ? 'Conectado' : 'Desconectado' }}
    </div>
  </div>

  <div class="admin-logs-toolbar">
    <div class="admin-logs-search">
      <i class="fa fa-search"></i>
      <input
        type="text"
        placeholder="Filtrar logs..."
        [(ngModel)]="filterText"
        (ngModelChange)="onFilterChange()"
      />
    </div>

    <button type="button" class="btn-dark" (click)="togglePause()">
      {{ paused ? 'Reanudar' : 'Pausar' }}
    </button>

    <button type="button" class="btn-light" (click)="clearLogs()">
      Limpiar
    </button>

    <button
      type="button"
      class="btn-primary"
      *ngIf="!connected"
      (click)="connect()"
    >
      Conectar
    </button>

    <button
      type="button"
      class="btn-danger"
      *ngIf="connected"
      (click)="disconnect()"
    >
      Desconectar
    </button>
  </div>

  <div class="admin-logs-terminal">
    <div class="admin-logs-empty" *ngIf="filteredLogs.length === 0">
      Esperando logs del servidor...
    </div>

    <div
      class="admin-logs-line"
      *ngFor="let item of filteredLogs; trackBy: trackByIndex"
      [ngClass]="item.type"
    >
      <span class="admin-logs-time">{{ item.time }}</span>
      <span class="admin-logs-text">{{ item.text }}</span>
    </div>

    <div #terminalBottom></div>
  </div>
</div>